export default {
  addExperience: "افزودن تجربه",
  aiPromptSetting: "پرامپت ai",
  Check: "چک",
  unit: "واحد",
  logisticsSchedule: "زمانبندی ارسال",
  Cash: "نقدی",
  outstanding_price: "مانده قبلی",
  accounting: "حسابدار",
  city: "شهر",
  neighborhood: "محله",
  registerDate: "تاریخ ثبت",
  daily: "روزانه",
  weekly: "هفتگی",
  monthly: "ماهانه",
  yearly: "سالانه",
  action: "عملیات",
  active: "فعال",
  activity: "فعالیت",
  add: "افزودن",
  addUser: "ثبت کاربر",
  address: "آدرس",
  addresses: "آدرس‌ها",
  mahak_res: "پاسخ محک",
  country: "کشور",
  addressHint:
    "ابتدا محدوده را روی نقشه مشخص و سپس آدرس را به صورت کامل وارد کنید",
  admin: "مدیر",
  remittance: "حواله های واریزی",
  all: "همه",
  amount: "مبلغ",
  android: "اندروید",
  answer: "پاسخ",
  app: "اپلیکیشن",
  backHome: "بازگشت به صفحه اصلی",
  bankInfo: "اطلاعات دریافتی از بانک",
  personCode: "کد اشخاص",
  barcode: "بارکد",
  basedOnMeters: "بر اساس متر",
  birthdate: "تاریخ تولد",
  bottom: "پایین",
  brand: "برند",
  bronze: "برنزی",
  buy: "خرید",
  calcPerMonth: "مبلغ خرید بر حسب ماه",
  cancel: "لغو",
  canceled: "لغو شده",
  cash: "نقدی",
  cardReader: "کارت خوان",
  carrier: "حمل کننده",
  category: "دسته‌بندی",
  banks: "بانک ها",
  bank: "بانک",
  center: "وسط",
  choose: "انتخاب کنید",
  chooseImage: "انتخاب تصویر",
  chooseLocation: "انتخاب مکان",
  client: "سفارش دهنده",
  close: "بستن",
  confirm: "تایید",
  confirmAddVIP: "از VIP کردن این کاربر اطمینان دارید؟",
  confirmCancelOrder: "از لغو این سفارش اطمینان دارید؟",
  confirmCatActivate: "از فعال کردن این دسته‌بندی اطمینان دارید؟",
  confirmCatDeactivate: "از غیرفعال کردن این دسته‌بندی اطمینان دارید؟",
  confirmDelete: "از حذف این آیتم اطمینان دارید؟",
  confirmDeleteCat: "از حذف این دسته‌بندی اطمینان دارید؟",
  confirmDeleteBank: "از حذف این بانک اطمینان دارید؟",
  confirmDeleteImage: "از حذف این تصویر اطمینان دارید؟",
  confirmDeleteMessage: "از حذف این پیام اطمینان دارید؟",
  confirmDeleteOffer: "از حذف این پیشنهاد اطمینان دارید؟",
  confirmDeleteOrder: "از حذف این سفارش اطمینان دارید؟",
  confirmDeleteProduct: "از حذف این محصول اطمینان دارید؟",
  confirmDeleteUser: "از حذف این کاربر اطمینان دارید؟",
  confirmDelVIP: "از غیر VIP کردن این کاربر اطمینان دارید؟",
  confirmActivate: "از فعال کردن این آیتم اطمینان دارید؟",
  confirmDeactivate: "از غیرفعال کردن این آیتم اطمینان دارید؟",
  confirmOfferActivate: "از فعال کردن این پیشنهاد اطمینان دارید؟",
  confirmOfferDeactivate: "از غیرفعال کردن این پیشنهاد اطمینان دارید؟",
  confirmProductActivate: "از فعال کردن این محصول اطمینان دارید؟",
  confirmProductDeactivate: "از غیرفعال کردن این محصول اطمینان دارید؟",
  confirmSuspendOrder: "از تعلیق این سفارش اطمینان دارید؟",
  confirmText: "آیا اطمینان دارید؟",
  confirmUserActivate: "از فعال کردن این کاربر اطمینان دارید؟",
  confirmUserDeactivate: "از غیرفعال کردن این کاربر اطمینان دارید؟",
  contactInfo: "اطلاعات تماس",
  continuation: "ادامه",
  copyright: "تمامی حقوق این وب سایت متعلق به دماوند مارکت می‌باشد.",
  costService: "هزینه خدمات دهی",
  costShippingRadius: "شعاع خدمات دهی",
  count: "تعداد",
  countPredictedDistance: "تعداد ارسال محصولات",
  courierList: "لیست پیک‌ها",
  credit: "اعتبار",
  credential: "اعتباری",
  dashboard: "پیشخوان",
  dataEntries: "ورودی‌ها",
  date: "تاریخ",
  hour: "ساعت",
  dateAndTime: "ساعت و تاریخ",
  dailyPosition: "تعداد فروش امروز",
  decrease: "کاهش",
  dedicated: "اختصاصی",
  delete: "حذف",
  excel: "اکسل",
  delivered: "تحویل",
  delivery: "پیک",
  description: "توضیحات",
  details: "جزئیات",
  device: "دستگاه",
  drafts: "پیش‌نویس‌ها",
  discount: "تخفیف",
  edit: "ویرایش",
  email: "ایمیل",
  endDate: "تاریخ پایان",
  enter: "ورود",
  enterCode: "کد پیامک را وارد کنید",
  enterMobile: "شماره همراه را وارد کنید",
  errorJpg: "شما فقط می‌توانید تصویر jpg بارگذاری کنید",
  errorPng: "شما فقط می‌توانید تصویر png بارگذاری کنید",
  factor: "فاکتور",
  faq: "سوالات متداول",
  filterByTime: "فیلتر بر اساس زمان",
  filterByMainCat: "فیلتر بر اساس دسته‌بندی اصلی",
  filterByOrderType: "فیلتر بر اساس نوع سفارش",
  filterByPayStatus: "فیلتر بر اساس وضعیت پرداخت",
  filterByPayType: "فیلتر بر اساس نوع پرداخت",
  filterByPermision: "فیلتر بر اساس سطح دسترسی",
  filterByStatus: "فیلتر بر اساس وضعیت",
  filterBySubCat: "فیلتر بر اساس دسته‌بندی فرعی",
  firstName: "نام",
  finalPrice: "قابل پرداخت",
  four: "چهار",
  freeShippingRadius: "شعاع حمل و نقل رایگان",
  from: "از",
  fromDate: "از تاریخ",
  fullName: "نام و نام خانوادگی",
  gold: "طلایی",
  grouping: "گروهی",
  image: "تصویر",
  images: "تصاویر",
  inactive: "غیرفعال",
  increase: "افزایش",
  information: "اطلاعات",
  inside: "محدوده",
  instagram: "اینستاگرام",
  inventory: "موجودی انبار",
  ios: "آی او اس",
  key: "کلید",
  lastName: "نام‌خانوادگی",
  latitude: "طول جغرافیایی",
  link: "لینک",
  list: "لیست",
  loading: "در حال بارگذاری...",
  location: "موقعیت",
  login: "پنل مدیریت",
  logout: "خروج از پنل",
  longitude: "عرض جغرافیایی",
  main: "اصلی",
  maximumShop: "کاربران با بیشترین خرید",
  maximumShopProduct: "محصولات با بیشترین خرید",
  message: "پیام",
  messages: "پیام‌ها",
  mobile: "موبایل",
  mobileHint: "09152222222",
  mobilePhone: "تلفن همراه / ثابت",
  mobilePhoneHint: "09152222222 / 0513222222",
  month: "ماه",
  move: "حرکت",
  nameHint: "ترجیحا به صورت فارسی وارد کنید",
  new: "جدید",
  no: "خیر",
  normal: "معمولی",
  notfound: "متأسفیم، چنین صفحه‌ای وجود ندارد.",
  notfoundCode: "۴۰۴",
  offBrands: "برندهای تخفیف‌دار",
  one: "یک",
  operator: "اپراتور",
  order: "سفارش",
  orders: "سفارشات",
  other: "سایر",
  otherPhones: "سایر تلفن‌ها",
  outside: "خارج",
  patterns: "اطلاعات وارد شده صحیح نمی‌باشد",
  payment: "پرداخت",
  permission: "دسترسی",
  permissions: "دسترسی‌ها",
  phone: "تلفن",
  postman: "پیک",
  port: "درگاه بانک",
  phoneOrders: "سفارشات تلفنی",
  pos: "کارت خوان",
  pointRank: "امتیاز و رتبه",
  product: "محصول",
  products: "محصولات",
  profile: "پروفایل",
  price: "قیمت",
  public: "عمومی",
  process: "پردازش",
  question: "سوال",
  questions: "سوالات",
  rank: "رتبه",
  record: "ثبت",
  recordAndPrint: "ثبت و پرینت",
  print: "پرینت",
  receive: "دریافت",
  receivedMessage: "پیام‌های دریافتی",
  receiver: "تحویل گیرنده",
  registrar: "ثبت کننده",
  report: "گزارش",
  required: "این فیلد الزامی می‌باشد",
  returned: "مرجوعی",
  rial: "ريال",
  safeFloor: "تعداد کف مطمئنه",
  shareFriends: "معرفی به دوستان",
  search: "جستجو...",
  searchReport: "گزارشات جستجو",
  advanceSearchReport : "گزارشات پیشرفته جستجو",
  searchHintCategory: "عنوان",
  searchHintMessageUser: "نام و نام خانوادگی، تلفن همراه",
  searchHintOffer: "عنوان و بارکد محصولات",
  searchHintOrder: "کاربر، تلفن، محصول، بارکرد و حمل کننده",
  searchHintProduct: "عنوان، دسته‌بندی، بارکد و قیمت",
  searchHintUser: "نام و نام خانوادگی، تلفن همراه و ثابت",
  section: "بخش",
  select: "انتخاب",
  sellingPrices: "مقدار فروش امروز",
  sendCode: "ارسال کد",
  sendNotif: "ارسال نوتیفیکیشن",
  sendToAll: "ارسال به همه کاربران",
  sendToBronze: "ارسال به کاربران برنزی",
  sendToGold: "ارسال به کاربران طلایی",
  sendToNormal: "ارسال به کاربران معمولی",
  sendToSilver: "ارسال به کاربران نقره‌ای",
  sendToVIP: "ارسال به کاربران VIP",
  serverError: "مشکلی در انجام عملیات به وجود آمده است",
  serverSuccess: "عملیات با موفقیت انجام شد",
  settings: "تنظیمات",
  shopPostman: "پیک فروشگاه",
  show: "نمایش",
  silver: "نقره‌ای",
  site: "سایت",
  slider: "اسلایدر",
  spec: "مشخصات",
  specialOffers: "پیشنهادات ویژه",
  specialOffersWarning: "حداقل 9 محصول باید انتخاب شود",
  startDate: "تاریخ شروع",
  status: "وضعیت",
  stop: "توقف",
  storeCourier: "پیک فروشگاه",
  sub: "فرعی",
  subCats: "زیر دسته‌ها",
  submit: "ارسال",
  successful: "موفق",
  sum: "جمع",
  sumDelivery: "هزینه ارسال محصولات",
  support: "پشتیبانی",
  suspend: "معلق",
  suspension: "تعلیق",
  suspensionFactors: "فاکتورهای تعلیقی",
  tag: "تگ",
  tags: "تگ‌ها",
  package: "پکیج ها",
  telegram: "تلگرام",
  terms: "قوانین و مقررات",
  text: "متن",
  title: "عنوان",
  code: "کد",
  three: "سه",
  to: "تا",
  toDate: "تا تاریخ",
  top: "بالا",
  total: "کل",
  trackingCode: "کد پیگیری",
  transferCost: "هزینه حمل",
  transferCostHelp: "عدم ورود مبلغ = محاسبه از روی نقشه",
  transportation: "حمل و نقل",
  two: "دو",
  type: "نوع",
  unauthorized: "متأسفیم، شما به این صفحه دسترسی ندارید.",
  unauthorizedCode: "۴۰۳",
  unknown: "ناشناس",
  unsuccessful: "ناموفق",
  uploadError: "مشکلی در ارسال فایل به وجود آمده است",
  uploadImage: "بارگذاری تصویر",
  uploadSuccess: "فایل با موفقیت بارگذاری شد",
  uploadText:
    "برای بارگیری عکس، روی این منطقه کلیک کنید یا عکس را اینجا رها کنید",
  user: "کاربر",
  userName: "نام کاربری",
  usersNow: "کاربران جدید این هفته",
  installedAppsCount: "تعداد اپ های نصب شده",
  usersApp: "کاربران اپ",
  users: "کاربران",
  view: "نمایش",
  vip: "VIP",
  hasPrice: "دارای قیمت",
  warehousing: "انبارداری",
  web: "وب",
  withoutBarcode: "فاقد بارکد",
  withoutCategory: "فاقد دسته‌بندی",
  withoutImage: "فاقد تصویر",
  withPhone: "تلفنی",
  yes: "بله",
  priceOne: "قیمت1",
  priceTwo: "قیمت2",
  priceThree: "قیمت3",
  reminderPay: "یادآوری پرداخت",
  payed: "پرداخت شده",
  confirmSendSms: "از ارسال پیامک اطمینان دارید؟",
  sendSms: "ارسال پیامک",
  customer: "مشتری",
  newFactor: "فاکتور جدید",
  isPay: "پرداخت شده",
  cashPrice: "قیمت نقدی",
  checkPrice: "قیمت چکی",
  selectCountry: "انتخاب کشور",
  smsCount: "تعداد پیامک",

  printBarcode: "چاپ بارکد",
  packing: "بسته بندی",
  row: "ردیف",
  identifier: "شناسه",
  shelf: "قفسه",
  size: "سایز",




};
